import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import {
  deleteMandatoryCheckTemplate,
  loadAllMandatoryChecksTemplates,
} from '../../store/global-settings.actions';
import { openDeleteConfirmationDialog } from 'src/app/shared/store/action-dialog/action-dialog.actions';
import { MandatoryCheckTemplateDialogFormComponent } from '../../components/mandatory-check-template-form-dialog/mandatory-check-template-form-dialog.component';
import { ImportExcelDialogComponent } from '../../../../_shared-by-role/import-excel-dialog/components/import-excel-dialog/import-excel-dialog.component';
import { openSpreadsheetDialog } from '../../../../_shared-by-role/import-excel-dialog/import-excel-dialog.functions';
import { ImportObjectTypes } from '../../../screening/screening.constants';

@Component({
  standalone: false,
  selector: 'app-mandatory-checks-templates',
  templateUrl: './mandatory-checks-templates.component.html',
  styleUrls: ['./mandatory-checks-templates.component.scss'],
})
export class MandatoryChecksTemplatesComponent {
  private importExcelDialogRef!: MatDialogRef<ImportExcelDialogComponent, any>;

  constructor(private store: Store<AppState>, private dialog: MatDialog) {
    this.store.dispatch(loadAllMandatoryChecksTemplates());
  }

  addMandatoryCheckTemplate() {
    this.openMandatoryCheckTemplateFormDialog();
  }

  editMandatoryCheckTemplate(mandatoryCheckTemplateId: string) {
    this.openMandatoryCheckTemplateFormDialog(mandatoryCheckTemplateId);
  }

  deleteMandatoryCheckTemplate(mandatoryCheckTemplateId: string) {
    this.store.dispatch(
      openDeleteConfirmationDialog({
        onConfirm: () => {
          this.store.dispatch(
            deleteMandatoryCheckTemplate({ mandatoryCheckTemplateId })
          );
        },
        description:
          'Are you sure you want to delete the selected mandatory check template? You cannot undo this action.',
      })
    );
  }

  private openMandatoryCheckTemplateFormDialog(
    mandatoryCheckTemplateId: string | null = null
  ) {
    const dialogRef = this.dialog.open(
      MandatoryCheckTemplateDialogFormComponent,
      {
        panelClass: 'mandatory-check-template-form-dialog',
        closeOnNavigation: false,
        disableClose: true,
        maxWidth: 'unset',
        data: mandatoryCheckTemplateId,
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      dialogRef.componentInstance.closeWindow();
    });
  }

  async importExcel() {
    this.importExcelDialogRef = openSpreadsheetDialog(
      this.dialog,
      ImportObjectTypes.MANDATORY_CHECKS,
      loadAllMandatoryChecksTemplates
    );
    this.importExcelDialogRef.afterClosed().subscribe(() => {
      this.importExcelDialogRef.componentInstance.closeWindow();
    });
  }
}
